module.exports = __webpack_public_path__ + "img/ban01.c642bdf.png";